'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name ratesTables
    * @description Initializes rates table behavior
    **/

    var initialize = function () {
        $('.rates-dd h4').on('click', function (e) {
            $(this).parent().toggleClass('active');
            $(this).parent().find('.rates-content').toggleClass('active');
        });
    }

    return {
        initialize: initialize
    };
}())